import { Brick, registerBrick, WorkflowObjectState} from 'olympe';
import BCP from './DM_BCP';
import { BCP_WORKFLOW_STATES } from './BcpWorkflowAuthorizations';
import { getLogger } from '@olympeio/core';

export default class DetermineQAAcceptanceInBcpRequest extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} bcpRequest
     * @param {*} curentWorkflow
     * @param {function()} forwardEvent
     */
    update($, [bcpRequest, curentWorkflow], [forwardEvent, setWhoApprovedQA1]) {
        const currentWorkflowState = curentWorkflow.get(WorkflowObjectState.stateProp);
        const currentWorkflowAssignee = curentWorkflow.get(WorkflowObjectState.assigneeProp).toLowerCase();
        let findWhoApproved;  
        if (currentWorkflowState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2) {  
        // Map for role identification  
            const rolesMap = {    
                1: "Accept as QA in the factory",  
                2: "Accept as SQA"  
            };  
     
            // Check if the assignee matches `qaInFactoryProp` or `qualityAssuranceProp`  
            const qaInFactory = bcpRequest.get(BCP.qaInFactoryProp).split(/[;:]/)[1].toLowerCase();  
            const qualityAssurance = bcpRequest.get(BCP.qualityAssuranceProp).split(/[;:]/)[1].toLowerCase();
            getLogger('Determine QA').info("currentWorkflowAssignee", currentWorkflowAssignee, bcpRequest.get(BCP.qaInFactoryProp)) ;
            getLogger('Determine QA').info("qaInFactory --- qualityAssurance", qaInFactory, qualityAssurance) ;
            const adminFirstApproval  = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
            if(adminFirstApproval){
                const adminFirstApproval  = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
                findWhoApproved = adminFirstApproval; // admin  
            }
            else{
                if (qaInFactory === qualityAssurance && qaInFactory === currentWorkflowAssignee) {  
                    findWhoApproved = rolesMap[1]; // qaInFactory if both match  
                } else if (qaInFactory === currentWorkflowAssignee) {  
                    findWhoApproved = rolesMap[1]; // qaInFactory  
                } else if (qualityAssurance === currentWorkflowAssignee) {  
                    findWhoApproved = rolesMap[2]; // qualityAssurance  
                } 
            }
            getLogger('Determine QA').info("Approval Role:", findWhoApproved);  
        }
        getLogger('Determine QA').info("bcp workflow", currentWorkflowState, currentWorkflowAssignee, findWhoApproved);
        setWhoApprovedQA1(findWhoApproved)
        forwardEvent();
    }
}

registerBrick('01935aa632d59cae3b12', DetermineQAAcceptanceInBcpRequest);
